import { render } from "./Campaign20241023.vue?vue&type=template&id=6b434c30&scoped=true"
import script from "./Campaign20241023.vue?vue&type=script&lang=js"
export * from "./Campaign20241023.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-6b434c30"

export default script